import React from "react";
import Autocomplete from '@mui/material/Autocomplete';
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { withStyles } from "@mui/styles";

import { ConfirmCancelDialog } from "../ConfirmCancelDialog";
import { LanguageContext } from '../LanguageContext';

const defaultToolbarStyles = {
    iconButton: {
    },
};

var iniCompany;
var iniOperator;

class ContractorsEdit extends React.Component {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);

        var data = props.Daatta.filter(function (d) {
            return d.contractorsId === props.rowId;
        });

        this.state = {
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            data: data,
            ContractorsId: data[0].contractorsId,
            Name: data[0].name,
            Description: data[0].description,
            Company_Id: data[0].company_Id,
            Operator_Id: data[0].operator_Id,
            Primary: data[0].primary,
            Modifier: data[0].modifier,
            StartTime: data[0].startTime,
            EndTime: data[0].endTime,
            company: (Object.keys(props.lookupLists.company).map((d) => ({ value: d, label: props.lookupLists.company[d] })) || []),
            operator: (Object.keys(props.lookupLists.operator).map((d) => ({ value: d, label: props.lookupLists.operator[d] })) || []),
        };

    }

    UNSAFE_componentWillMount() {
        iniCompany = this.state.company.find(({ value }) => value === (this.state.Company_Id || '').toString());
        iniOperator = this.state.operator.find(({ value }) => value === (this.state.Operator_Id || '').toString());
    }

    handleClearData = () => {
        this.setState({
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            ContractorsId: this.state.data[0].contractorsId,
            Name: this.state.data[0].name,
            Description: this.state.data[0].description,
            Company_Id: this.state.data[0].company_Id,
            Operator_Id: this.state.data[0].operator_Id,
            Primary: this.state.data[0].primary,
            Modifier: this.state.data[0].modifier,
            StartTime: this.state.data[0].startTime,
            EndTime: this.state.data[0].endTime
        });
    }

    handleSave = () => {
        this.props.onEditRow({
            ContractorsId: this.state.ContractorsId,
            Name: this.state.Name,
            Description: this.state.Description,
            Company_Id: this.state.Company_Id,
            Operator_Id: this.state.Operator_Id,
            Primary: this.state.Primary,
            Modifier: this.state.Modifier,
            StartTime: this.state.StartTime,
            EndTime: this.state.EndTime
        });

        this.handleClearData();
    }

    closeDialog = (list) => {
        var name = 'open' + list;
        this.setState({ [name]: false })
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
            jotainMuuttui: true
        });
    };

    handleClickOpen = () => {
        this.setState({
            open: true,
        });
    }

    handleListChange = (event, newValue, item) => {
        if (newValue != null) {
            this.setState({ [item]: newValue.value })
        }
        else {
            this.setState({ [item]: null })
        }
        this.setState({ jotainMuuttui: true })
    }

    handleClose = () => {
        if (this.state.jotainMuuttui) {
            this.setState({
                setOpen: true
            });
        }
        else {
            this.setState({
                open: false,
                setOpen: false
            });
        }
    }

    handleSetOpenCancel = () => {
        this.setState({
            open: true,
            setOpen: false
        });
    }

    render() {
        const { dictionary } = this.context;
        const { open, company, operator } = this.state;

        return (
            <React.Fragment>
                <Tooltip title={dictionary.Toolbar.Edit}>
                    <IconButton onClick={this.handleClickOpen}>
                        <EditIcon />
                    </IconButton>
                </Tooltip>

                <Dialog open={open} onClose={this.handleClose}>
                    <DialogTitle>{dictionary.Contractors.Title}</DialogTitle>
                    <DialogContent style={{ width: "500px" }}>
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.Contractors.Columns[1]}
                            type="text"
                            fullWidth
                            value={this.state.Name}
                            onChange={this.handleChange('Name')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.Contractors.Columns[2]}
                            type="text"
                            fullWidth
                            value={this.state.Description}
                            onChange={this.handleChange('Description')}
                        />
                        <Box style={{ display: 'flex', paddingTop: "10px" }} >
                            <Autocomplete
                                defaultValue={iniCompany}
                                onChange={(event, newValue) => this.handleListChange(event, newValue, 'Company_Id')}
                                options={company}
                                style={{ width: 400 }}
                                renderInput={(params) => <TextField  {...params} required={true} variant="standard" label={dictionary.Contractors.Columns[3]} />}
                            />
                        </Box>
                        <Box style={{ display: 'flex', paddingTop: "10px" }} >
                            <Autocomplete
                                defaultValue={iniOperator}
                                onChange={(event, newValue) => this.handleListChange(event, newValue, 'Operator_Id')}
                                options={operator}
                                style={{ width: 400 }}
                                renderInput={(params) => <TextField  {...params} required={true} variant="standard" label={dictionary.Contractors.Columns[4]} />}
                            />
                        </Box>
                        <TextField
                            margin="dense"
                            label={dictionary.Contractors.Columns[5]}
                            type="text"
                            fullWidth
                            value={this.state.Primary}
                            onChange={this.handleChange('Primary')}
                        />
                    </DialogContent>
                    <DialogActions
                        style={{ backgroundColor: "#3C495A" }}
                    >
                        <ButtonGroup variant="comboButton">
                            <Button variant="Secondary" onClick={this.handleClose}>
                                {dictionary.Close}
                            </Button>
                            <Button variant="Primary" onClick={this.handleSave}>
                                {dictionary.Save}
                            </Button>
                        </ButtonGroup>
                    </DialogActions>
                </Dialog>
                <ConfirmCancelDialog
                    open={this.state.setOpen}
                    onCancel={this.handleSetOpenCancel}
                    onOk={this.handleClearData}
                />

            </React.Fragment>
        );
    }
}

export default withStyles(defaultToolbarStyles, { name: "ContractorsEdit" })(ContractorsEdit);
